import React from 'react';

interface DelayedProps {}

interface DelayedState {
  hidden: boolean;
}

export default class DelayedUntilLoad extends React.Component<DelayedProps, DelayedState> {
  constructor(props: DelayedProps) {
    super(props);
    this.state = { hidden: true };
  }

  componentDidMount() {
    window.addEventListener('load', () => setTimeout(() => this.setState({ hidden: false }), 3000));
  }

  render() {
    return !this.state.hidden && this.props.children;
  }
}
